import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { useTheme } from '../../themes/ThemeProvider';
import { sharedUiTranslations } from '../../translations';
import { Icon } from '../Icon';
import styles from './HeaderCompanySelector.module.css';
export const HeaderCompanySelectorBase = ({ companyName, interactive = true, focused = false, onClick, className, style, ...props }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const chevronColor = theme['header-company-selector-focus-border'] || '#D64000';
    const handleClick = () => {
        if (interactive && onClick) {
            onClick();
        }
    };
    const handleKeyDown = (event) => {
        if (interactive && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleClick();
        }
    };
    const combinedClassName = [
        styles.container,
        interactive && styles.containerInteractive,
        focused && styles.containerFocused,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: combinedClassName, style: style, onClick: handleClick, onKeyDown: handleKeyDown, tabIndex: interactive ? 0 : -1, role: interactive ? 'button' : 'presentation', "aria-label": interactive ? t('header-company-selector.aria-label', { companyName }) : undefined, "data-testid": 'header-company-selector-container', ...props, children: [_jsxs("div", { className: styles.companyInfo, "data-testid": 'header-company-selector-company-section', children: [_jsx("span", { className: styles.label, "data-testid": 'header-company-selector-company-label', children: t('header-company-selector.label') }), _jsx("span", { className: styles.value, "data-testid": 'header-company-selector-company-name', title: companyName, children: companyName })] }), interactive && (_jsx("div", { className: styles.chevron, "data-testid": 'header-company-selector-chevron', children: _jsx(Icon, { name: 'arrowChevronDown', tintColor: chevronColor }) }))] }));
};
export const HeaderCompanySelector = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(HeaderCompanySelectorBase, { ...props }) }));
};
export default HeaderCompanySelector;
